module.exports = __webpack_public_path__ + "static/media/Practitioners_Videocalls.50fd055e.png";